import { useScript } from '@ecomm/shared-hooks'
import { getSprChat, setSprinklrChatAppId } from '@ecomm/shared-window'
import { getLiveChatScriptUrl } from '../getLiveChatScriptUrl'

import { useLocale } from '@ecomm/data-hooks'
import { useEffect } from 'react'
import { salesChatAppId } from '../chatAppId'
import { useIsLiveChatSupportedForRoute } from '../useIsLiveChatSupportedForRoute'
import { useLiveChatAvailability } from '../useLiveChatAvailability'
import { useLiveChatTracking } from '../useLiveChatTracking'

// The underlying embed code. Loads the Sprinklr LiveChat script to the document
// after defining its settings on the window object.
function LiveChatScript() {
  setSprinklrChatAppId(salesChatAppId)

  const status = useScript(getLiveChatScriptUrl(salesChatAppId))

  useLiveChatTracking(status)
  return null
}

// Wrapper component to dynamically enable livechat according to agent availability and the user's current route.
/**
 * Enables Sprinklr livechat on page. Requires page to be whitelisted with Sprinklr and for the page to have live chat supported.
 * Hard-coded to sales chat experience.
 */
export function LiveChat() {
  const locale = useLocale()
  const areAgentsAvailable = useLiveChatAvailability()
  const isRouteEnabled = useIsLiveChatSupportedForRoute()

  const enabled = areAgentsAvailable && isRouteEnabled && locale === 'en-US'

  // This useEffect hides or shows the Sprinklr widget based on the available agents
  // and the user's current page. Without this useEffect, the live chat script will load
  // the chat widget and it will follow the user around on every page, which isn't desired.
  useEffect(() => {
    getSprChat(sprChat => sprChat(enabled ? 'enable' : 'disable'))
  }, [enabled])

  return enabled ? <LiveChatScript /> : null
}
